"use strict";
// Copyright © Veeam Software Group GmbH
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RepositoriesDialog = void 0;
const react_1 = __importStar(require("react"));
const components_1 = require("@veeam/components");
const core_1 = require("@veeam/core");
const constants_1 = require("../../../constants");
const core_2 = require("../../../core");
require("./types");
const Repositories_1 = require("../../Repositories");
const RepositoriesDialog = ({ dataGridLoader, repositoryId, onDeactivate, onDone, onCancel, onClose, displayedColumns, texts, }) => {
    const { t } = core_2.useFeatureContext();
    const { interactor } = core_1.useInteractor(() => {
        const dataGridModel = new Repositories_1.RepositoriesDataGridModel(dataGridLoader)
            .withSorting({
            key: 'name',
            direction: components_1.SORT_DIRECTION.asc,
        })
            .withPagination({
            offset: constants_1.GRID.initialOffset,
            limit: constants_1.GRID.pageLimit,
        });
        const listener = {
            onDeactivate,
            onDone,
            onCancel,
            onClose,
        };
        return new Repositories_1.RepositoriesInteractor(dataGridModel, listener);
    });
    const { value: dataGridModelValue } = core_1.useModel(interactor.dataGridModel);
    const isDoneHandlerDisabled = !dataGridModelValue.selection.length;
    react_1.useEffect(() => {
        if (!repositoryId) {
            return;
        }
        interactor.dataGridModel.update((value) => {
            value.selection = [repositoryId];
        });
    }, [repositoryId]);
    return (react_1.default.createElement(components_1.Dialog, { id: "repositoriesDialog", header: (texts === null || texts === void 0 ? void 0 : texts.header) || t('repositoriesDialog|header'), hasTopPadding: false, size: {
            width: components_1.DIALOG_SIZE.xl,
            height: components_1.DIALOG_SIZE.xxl,
        }, onRequestClose: () => {
            interactor.onClose();
        }, actions: [
            {
                view: components_1.ACTION_VIEW.primary,
                text: (texts === null || texts === void 0 ? void 0 : texts.buttonDone) || t('repositoriesDialog|actions|done|label'),
                disabled: isDoneHandlerDisabled,
                onClick: () => {
                    interactor.onDone();
                },
            },
            {
                view: components_1.ACTION_VIEW.secondary,
                text: (texts === null || texts === void 0 ? void 0 : texts.buttonCancel) || t('repositoriesDialog|actions|cancel|label'),
                onClick: () => {
                    interactor.onCancel();
                },
            },
        ] },
        react_1.default.createElement(components_1.StackView, { direction: components_1.STACK_DIRECTION.column, distribution: components_1.STACK_DISTRIBUTION.lastFill, gap: components_1.STACK_GAP.m, indentTop: components_1.INDENT.m },
            react_1.default.createElement("div", null,
                react_1.default.createElement(components_1.NoteBar, { shrink: true }, (texts === null || texts === void 0 ? void 0 : texts.information) || t('repositoriesDialog|information'))),
            react_1.default.createElement(Repositories_1.RepositoriesGrid, { dataGridModel: interactor.dataGridModel, displayedColumns: displayedColumns }))));
};
exports.RepositoriesDialog = RepositoriesDialog;
//# sourceMappingURL=RepositoriesDialog.js.map